export const GET_SESSIONS = "GET_SESSIONS"
export const GET_SESSIONS_FAIL = "GET_SESSIONS_FAIL"
export const GET_SESSIONS_SUCCESS = "GET_SESSIONS_SUCCESS"

export const ADD_NEW_SESSION = "ADD_NEW_SESSION"
export const ADD_SESSION_SUCCESS = "ADD_SESSION_SUCCESS"
export const ADD_SESSION_FAIL = "ADD_SESSION_FAIL"

export const UPDATE_SESSION = "UPDATE_SESSION"
export const UPDATE_SESSION_SUCCESS = "UPDATE_SESSION_SUCCESS"
export const UPDATE_SESSION_FAIL = "UPDATE_SESSION_FAIL"

export const DELETE_SESSION = "DELETE_SESSION"
export const DELETE_SESSION_SUCCESS = "DELETE_SESSION_SUCCESS"
export const DELETE_SESSION_FAIL = "DELETE_SESSION_FAIL"


export const GET_SESSION_RESULTS         = "GET_SESSION_RESULTS";
export const GET_SESSION_RESULTS_SUCCESS = "GET_SESSION_RESULTS_SUCCESS";
export const GET_SESSION_RESULTS_FAIL    = "GET_SESSION_RESULTS_FAIL";




export const PROCLAMER_SESSION         = "PROCLAMER_SESSION";
export const PROCLAMER_SESSION_SUCCESS = "PROCLAMER_SESSION_SUCCESS";
export const PROCLAMER_SESSION_FAIL    = "PROCLAMER_SESSION_FAIL";


// GET PROCLAMATION RESULTS
export const GET_PROCLAMATION_RESULTS         = "GET_PROCLAMATION_RESULTS";
export const GET_PROCLAMATION_RESULTS_SUCCESS = "GET_PROCLAMATION_RESULTS_SUCCESS";
export const GET_PROCLAMATION_RESULTS_FAIL    = "GET_PROCLAMATION_RESULTS_FAIL";




export const SAVE_FINAL_DECISION = "SAVE_FINAL_DECISION";
export const SAVE_FINAL_DECISION_SUCCESS = "SAVE_FINAL_DECISION_SUCCESS";
export const SAVE_FINAL_DECISION_FAIL = "SAVE_FINAL_DECISION_FAIL";

export const GET_FINAL_DECISION = "GET_FINAL_DECISION";
export const GET_FINAL_DECISION_SUCCESS = "GET_FINAL_DECISION_SUCCESS";
export const GET_FINAL_DECISION_FAIL = "GET_FINAL_DECISION_FAIL";




export const RUN_ANNUAL_DELIBERATION = "RUN_ANNUAL_DELIBERATION";
export const RUN_ANNUAL_DELIBERATION_SUCCESS = "RUN_ANNUAL_DELIBERATION_SUCCESS";
export const RUN_ANNUAL_DELIBERATION_FAIL = "RUN_ANNUAL_DELIBERATION_FAIL";